import { Component } from '@angular/core';

@Component({
  selector: 'app-modal-api-instruction',
  templateUrl: './modal-api-instruction.component.html',
  styleUrls: ['./modal-api-instruction.component.scss']
})
export class ModalApiInstructionComponent {
  public modalShow = false;
  public isDarkBackground = false;

  modalApiInstructionShow() {
    this.modalShow = true;
    this.isDarkBackground = true;
  }

  closeModal() {
    this.modalShow = false;
    this.isDarkBackground = false;
  }
}
